import StarIcon from "@uui/Star06";

import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import { Row, StackProps } from "@rui/Stack";

const Container = styled(Row)(({ theme }) => ({
  backgroundColor: theme.palette.shades.ghost[500],
  borderRadius: "8px",
  padding: theme.spacing(1),
  color: theme.palette.shades.neutral[600],
  "& svg": {
    color: theme.palette.shades.primary[500],
    fontSize: "18px",
  },
}));

interface TipProps extends StackProps {
  Icon?: typeof StarIcon;
}

const Tip = ({ Icon = StarIcon, children, ...props }: TipProps) => (
  <Container spacing={1} {...props}>
    <Icon />
    <Typography variant="bodySecondaryReg">{children}</Typography>
  </Container>
);

export default Tip;
